import {
    createAsyncThunk,
    createSlice,
} from '@reduxjs/toolkit';

import {
    add,
    deleteRecord,
    fetch,
    fetchRecords,
    update,
} from '../services/OrganizationsService.ts';


import {
    deleteOneCase,
    fetchManyCase,
    fetchOneCase,
    saveOneCase,
    updateOneCase,
} from '../../../../store/RecordsSliceCaseHelpers';
import {Organization} from '../types';

const entityKey = 'organizations';

interface OrganizationsState {
    byId: { [key: string]: Organization },
    ids: string[],
    totalCount: number,
    loading: boolean,
    error: string
}

const initialState = {
    byId: {},
    ids: [],
    totalCount: 0,
    loading: false,
    error: '',
} as OrganizationsState;


const normalizeRecord = (record: Organization) => {
    return Object.assign({}, record);
};

// generates pending, fulfilled and rejected
export const fetchOrganizations = createAsyncThunk(
    `${entityKey}/fetchRecords`,
    (query: { [k: string]: string }) => {

        return fetchRecords(query)
            .then((response) => {
                if (response) {
                    return response.map((record: Organization) => {
                        return normalizeRecord(record);
                    });
                }
            });
    },
);

export const fetchOrganization = createAsyncThunk(
    `${entityKey}/fetch`,
    (id: string) => {
        return fetch(id)
            .then((response) => {
                if (typeof response !== 'undefined') {
                    return normalizeRecord(response);
                }
            });
    });

export const saveOrganization = createAsyncThunk(
    `${entityKey}/add`,
    (payload: Organization) => {
        return add(payload)
            .then((response) => {
                if (response) {
                    return normalizeRecord(response);
                }
            });
    });

export const updateOrganization = createAsyncThunk(
    `${entityKey}/update`,
    ({
         id,
         record,
     }: { id: string, record: Organization }) => {

        return update(id, record)
            .then((response) => {
                if (response) {
                    return normalizeRecord(response);
                }
            });
    },
);

export const deleteOrganization = createAsyncThunk(
    `${entityKey}/deleteRecord`,
    (id: string) => {
        return deleteRecord(id)
            .then(() => id);
    },
);


export const storeOrganization = createAsyncThunk(
    `${entityKey}/store`,
    (payload: Organization) => {
        return normalizeRecord(payload);
    },
);


const componentsSlice = createSlice({
                                        name: entityKey,
                                        initialState,
                                        reducers: {
                                            clearState: () => initialState,
                                        },
                                        extraReducers: (builder) => {
                                            // FETCH MANY
                                            fetchManyCase(builder, fetchOrganizations, entityKey);

                                            // FETCH ONE
                                            fetchOneCase(builder, fetchOrganization);

                                            // SAVE ONE
                                            saveOneCase(builder, saveOrganization);

                                            // UPDATE ONE
                                            updateOneCase(builder, updateOrganization);

                                            updateOneCase(builder, storeOrganization);

                                            // DELETE ONE
                                            deleteOneCase(builder, deleteOrganization);
                                        },
                                    });

export default componentsSlice.reducer;
